import { render, staticRenderFns } from "./CcfoliaFormatter.vue?vue&type=template&id=1f65c413&"
import script from "./CcfoliaFormatter.vue?vue&type=script&lang=js&"
export * from "./CcfoliaFormatter.vue?vue&type=script&lang=js&"
import style0 from "./CcfoliaFormatter.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports